import React from 'react';

export const ThumbsUp = () => <span className='added-players-list-row-wants-win-toggle-status'>&#128077;</span>;